module.exports = __webpack_public_path__ + "static/gruener-knopf-f2f969a98f7167d9c9279873ef26683f.jpg";